import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isSidebarCollapsed: false
};

export const sliceName = 'sidebar'

export const sidebar = createSlice({
  name: sliceName,
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setSidebarCollapse: (state, action) => {
      state.isSidebarCollapsed = action.payload
    }
  }
});

export const { setSidebarCollapse } = sidebar.actions;

export const selectSidebarCollapseStatus = (state) => state[sliceName].isSidebarCollapsed;

export default sidebar.reducer;
